<template>
  <div>
    <template v-if="!isLoaded">
      <slot name="placeholder">
        <app-spinner class="global-spinner" transparent-mode data-global-spinner />
      </slot>
    </template>

    <template v-else>
      <slot></slot>
    </template>

    <prevent-webshop-access-modal v-if="!hasWebshopAccess" ref="preventWebshopAccessModal" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import AppSpinner from '@/components/common/AppSpinner.vue';

import { getDecodedId } from '@/utils/hashids';
import { isOfferPaid } from '@/api/auth.api';

import { types } from '@/store/types';

export default {
  name: 'EntryPointPageTemplate',
  components: {
    AppSpinner,
    PreventWebshopAccessModal: () =>
      import('@/components/welcome-page/PreventWebshopAccessModal.vue')
  },
  props: {
    doctorSlug: {
      type: String,
      required: true
    },
    hashedDataId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoaded: false
    };
  },
  computed: {
    ...mapState({
      initialPageData: types.state.INITIAL_PAGE_DATA
    }),
    hasWebshopAccess() {
      return this.initialPageData && this.initialPageData.hasWebshopAccess;
    }
  },
  async created() {
    await this.loadSiteData({ hashedDataId: this.hashedDataId, doctorSlug: this.doctorSlug });

    this.isLoaded = true;

    setTimeout(() => {
      // Added to solve issue with scrolling to saved position when return back.
      // In router hook we subscribe on event when the data probably loaded to initiate scroll to saved postion.
      window.dispatchEvent(new CustomEvent('page-loaded'));
    }, 100);

    if (!this.initialPageData.hasWebshopAccess) {
      this.$refs.preventWebshopAccessModal.open();

      return;
    }

    const decodedId = getDecodedId(this.hashedDataId);
    const { data: isPaidData } = await isOfferPaid(decodedId);

    if (isPaidData.paid) {
      await this.$router.push({ name: 'ValidationPage', query: { allowRenew: 'true' } });
    }
  },
  methods: {
    ...mapActions({
      loadSiteData: types.actions.LOAD_SITE_DATA
    })
  }
};
</script>
